import {defineMessages} from "@project/i18n";

export const offerTemplateFieldLabelIds = {
  name: "fields.offerTemplate.name",
  language: "fields.offerTemplate.language",
  currency: "fields.offerTemplate.currency",
  content: "fields.offerTemplate.content",
  state: "fields.offerTemplate.state",
} as const;
export const offerTemplateFieldMessages = defineMessages({
  name: {
    id: "fields.offerTemplate.name",
    defaultMessage: "Name",
    description: "OfferTemplate semantic field label for name",
  },
  language: {
    id: "fields.offerTemplate.language",
    defaultMessage: "Language",
    description: "OfferTemplate semantic field label for language",
  },
  currency: {
    id: "fields.offerTemplate.currency",
    defaultMessage: "Currency",
    description: "OfferTemplate semantic field label for currency",
  },
  content: {
    id: "fields.offerTemplate.content",
    defaultMessage: "Content",
    description: "OfferTemplate semantic field label for content",
  },
  state: {
    id: "fields.offerTemplate.state",
    defaultMessage: "State",
    description: "OfferTemplate semantic field label for state",
  },
});
export const offerTemplateValidationMessages = defineMessages({
  duplicateIdentity: {
    id: "validation.offerTemplate.duplicateIdentity",
    defaultMessage: "This identity already exists in its content scope.",
    description: "Reject duplicate content identities or scope-local variable names",
  },
});
